import { HTTP } from "./http-common";
import { DIETARY_ALLERGIES } from "../constants";

const commonAPI = {
  fetchDietaryAllergies() {
    return HTTP.get(
      `${process.env.MARKETING_SITE_BACKEND_URL}/api/v0/dietary-allergies`,
    )
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        console.log(
          "using fallback value due to unable to retrieve dietary allergies from api:",
          error,
        );
        return DIETARY_ALLERGIES;
      });
  },
};

export default commonAPI;



// WEBPACK FOOTER //
// ./src/api/common.js